import { CREATE_POSTS_START } from "../../types";

export const create_post = (payload) => ({
  type: CREATE_POSTS_START,
  payload,
});
